import { propEq, find, contains } from 'ramda';
import { UserRole } from '../../../../../constants/UserRole';
import { MediaManagerSDKTeam, MediaManagerSDKTeamMember } from '../../../../../utils/media-manager-sdk';

export const findOwner = (team: MediaManagerSDKTeam) =>
  find<MediaManagerSDKTeamMember>(propEq('userId', team.ownerId))(team.members);

export const isOwner = ({ roles }: MediaManagerSDKTeamMember): boolean => contains(UserRole.Owner, roles);
